import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/kuden-legend/kuden-legend/frontend/business/src/app/analytics.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/kuden-legend/kuden-legend/frontend/business/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/home/runner/work/kuden-legend/kuden-legend/frontend/business/src/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/kuden-legend/kuden-legend/frontend/business/src/app/reset.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/kuden-legend/kuden-legend/frontend/business/src/components/basics/ToastWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/kuden-legend/kuden-legend/frontend/business/src/components/basics/TopLoader.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/kuden-legend/kuden-legend/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Noto_Sans_JP\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"notoSansJP\"}");
